import React from "react";

const PublishedCoursesIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.667"
      height="59.164"
      viewBox="0 0 26.667 59.164"
    >
      <g id="db15" transform="translate(0 -0.125)">
        <path
          id="Path_1178"
          data-name="Path 1178"
          d="M100,375.437a1.157,1.157,0,1,1,2.314,0v11.324a1.158,1.158,0,0,1-2.314,0Z"
          transform="translate(-87.823 -328.569)"
          fill={fill ? fill : "#7effaa"}
        />
        <path
          id="Path_1179"
          data-name="Path 1179"
          d="M66,352.437a1.157,1.157,0,1,1,2.314,0v8.524a1.158,1.158,0,0,1-2.314,0Z"
          transform="translate(-57.963 -308.37)"
          fill={fill ? fill : "#7effaa"}
        />
        <path
          id="Path_1180"
          data-name="Path 1180"
          d="M135,352.437a1.157,1.157,0,1,1,2.314,0v8.524a1.158,1.158,0,0,1-2.314,0Z"
          transform="translate(-118.561 -308.37)"
          fill={fill ? fill : "#7effaa"}
        />
        <path
          id="Path_1181"
          data-name="Path 1181"
          d="M5.967,225.376,0,230.125C.122,220.262.609,220.14,4.262,216A38,38,0,0,0,5.967,225.376Z"
          transform="translate(0 -189.589)"
          fill={fill ? fill : "#7effaa"}
          fillRule="evenodd"
        />
        <path
          id="Path_1182"
          data-name="Path 1182"
          d="M171,225.376l5.845,4.749c-.122-9.863-.609-9.985-4.14-14.125A54.26,54.26,0,0,1,171,225.376Z"
          transform="translate(-150.178 -189.589)"
          fill={fill ? fill : "#7effaa"}
          fillRule="evenodd"
        />
        <path
          id="Path_1183"
          data-name="Path 1183"
          d="M58.62,10.947c1.827,5.48,1.1,20.457-1.7,26.423H46.078c-2.8-5.845-3.409-20.944-1.583-26.423C49.365-3.422,53.627-3.544,58.62,10.947Zm-7.062,0a4.782,4.782,0,0,1,4.749,4.871,4.782,4.782,0,0,1-4.749,4.871,4.871,4.871,0,1,1,0-9.741Z"
          transform="translate(-38.163)"
          fill={fill ? fill : "#7effaa"}
          fillRule="evenodd"
        />
        <circle
          id="Ellipse_320"
          data-name="Ellipse 320"
          cx="2.801"
          cy="2.801"
          r="2.801"
          transform="translate(10.594 13.017)"
          fill={fill ? fill : "#7effaa"}
        />
        <path
          id="Path_1184"
          data-name="Path 1184"
          d="M77.35,317v2.557H67V317Z"
          transform="translate(-58.842 -278.29)"
          fill={fill ? fill : "#7effaa"}
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export default PublishedCoursesIcon;
